// ListToolbar — barra de acciones de una lista: acciones primarias (ej. "+ Nuevo") + búsqueda +
// filtros, en una fila que colapsa en wrap. Todos los slots son opcionales; el caller decide qué
// poner y en qué orden visual. Reproduce la fila "[+ Nuevo X] [Buscar...] [Filtrar: …]" de M6.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface ListToolbarProps {
    actions?: ReactNode;
    search?: ReactNode;
    filters?: ReactNode;
    className?: string;
}

export function ListToolbar({ actions, search, filters, className }: ListToolbarProps) {
    return (
        <div className={cn('flex flex-wrap items-center gap-3', className)}>
            {actions}
            {search ? <div className="min-w-[16rem] flex-1">{search}</div> : null}
            {filters}
        </div>
    );
}
